"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitScreenSwitcher = void 0;
const react_1 = __importStar(require("react"));
const split_screen_styles_1 = require("./split-screen-styles");
const ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
const ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const react_use_measure_1 = __importDefault(require("react-use-measure"));
function SplitScreenSwitcher({ handleDragStart, handleLeftClicked, handleRightClicked, leftLabel, leftDisabled = false, rightLabel, rightDisabled = false, }) {
    const classes = split_screen_styles_1.useStyles();
    /**
     * In order to make the label visible when on the edge of screen, the width of both buttons needs to be the same.
     */
    const [leftRef, { width: leftBtnWidth }] = react_use_measure_1.default();
    const [rightRef, { width: rightBtnWidth }] = react_use_measure_1.default();
    const btnWidth = react_1.useMemo(() => !leftLabel && !rightLabel ? 40 : Math.max(leftBtnWidth, rightBtnWidth), [leftBtnWidth, leftLabel, rightBtnWidth, rightLabel]);
    return (react_1.default.createElement("div", { className: classes.switcherWrapper },
        react_1.default.createElement(Button_1.default, { size: "small", ref: leftRef, className: classes.switcherButton, disabled: leftDisabled, style: { width: btnWidth, borderRadius: '16px 0 0 16px' }, onClick: handleLeftClicked },
            react_1.default.createElement(ChevronLeft_1.default, null),
            rightLabel),
        react_1.default.createElement("div", { className: classes.switcherHandle, onMouseDown: handleDragStart }, "\u22EE"),
        react_1.default.createElement(Button_1.default, { size: "small", ref: rightRef, className: classes.switcherButton, disabled: rightDisabled, style: { width: btnWidth, borderRadius: '0 16px 16px 0' }, onClick: handleRightClicked },
            leftLabel,
            react_1.default.createElement(ChevronRight_1.default, null))));
}
exports.SplitScreenSwitcher = SplitScreenSwitcher;
//# sourceMappingURL=split-screen-switcher.js.map